import { objectSchemaOf, Joi, actionCreator } from '../helpers';
import { INVITATIONS_OUTPUT } from './topics';
import type { IInvitation } from './invitation';
import { invitationSchema } from './invitation';

export const CREATED = 'INVITATIONS/CREATED' as const;

export type ICreatedPayload = IInvitation;

export interface ICreatedAction {
  type: typeof CREATED;
  payload: ICreatedPayload;
}

export const createdActionSchema = objectSchemaOf<ICreatedAction>({
  type: Joi.string().required().valid(CREATED),
  payload: invitationSchema.required(),
});

export const created = actionCreator({
  type: CREATED,
  topic: INVITATIONS_OUTPUT,
  schema: createdActionSchema,
});
